import angular from 'angular';
import components from './components';

export default angular.module('addressLookupModal.scenes', [components]).name;
